import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { errorMsg } from "../../../Apis/functions";
import { GetBuildingApartmentById } from "../../../reduxToolkit/Building/BuildingApi";
import { RESIDENT_HOUSEHOLD_MODEL } from "../Model/Model";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Details logic of one registered resident: the residents of their apartment are
 * loaded every time the modal is opened and the resident of the card is left out
 * of them, the rest are the household members the card grid renders.
 *
 * @param {Object} props
 * @param {boolean} props.show - Modal visibility, the fetch runs when it opens.
 * @param {Object} props.item - Resident shown in the modal.
 * @returns {Object} Localization function, the household and its loading flag.
 */
export const ResidentDetailsModalApp = ({ show, item }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [household, setHousehold] = useState(RESIDENT_HOUSEHOLD_MODEL);
    const [loading, setLoading] = useState(false);
    // Apartment of the resident, the search of the grid names it either way
    const apartmentId = item?.buildingApartmentId || item?.apartmentId;

    // The residents are read again on every open, they change from the tabs of
    // the detail while the modal stays mounted
    useEffect(() => {
        if (!show || !apartmentId) {
            setHousehold(RESIDENT_HOUSEHOLD_MODEL);
            return;
        }

        getHousehold();
    }, [show, apartmentId]);

    /**
     * Loads the residents of the apartment the resident of the modal lives in.
     */
    const getHousehold = () => {
        setLoading(true);

        dispatch(GetBuildingApartmentById(apartmentId)).then((response) => {
            const { success, data, code } = response?.payload?.data || {};
            setLoading(false);

            if (!success) {
                errorMsg(code);
                return;
            }

            setHousehold(RESIDENT_HOUSEHOLD_MODEL.set(data, item?.id));
        });
    };

    return {
        t,
        household,
        loading
    };
};
